import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import ErrorMessage from '@/forms/_common/ErrorMessage';
import useDialogConfig from '@/dialogs-routable/_hooks/useDialogConfig';
import ProjectTitleEditDialog from '@/dialogs-routable/project_title_edit';

Launcher.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default function Launcher(props) {
  const config = useDialogConfig();

  const project = useConnect('project.byId', {
    id: config.params.projectId
  });

  if (project.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (project.state === PayloadStates.NOT_FOUND) {
    return (
      <ErrorMessage>
        Project not found.
      </ErrorMessage>
    );
  }

  if (project.state === PayloadStates.ERROR_FETCHING) {
    return (
      <ErrorMessage>
        An error occurred while loading the project.
      </ErrorMessage>
    );
  }

  return (
    <ProjectTitleEditDialog
      project={project}
      onCancel={props.onClose}
    />
  );
}
